import {
  APP_CONTAINER_ROUTES,
  APP_MODAL_ROUTES,
  INSIGHTS_HUB_ROUTES,
  LOCATION_MANAGER_ROUTES,
} from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { getTranslationValue } from '@/utils/translations';
import { HubCardData } from './types';
import { HubCardType, OverduePaymentHubCardData } from '@/types';
import { StackNavigationProp } from '@react-navigation/stack';

type Navigation = CompositeNavigationProp<
  StackNavigationProp<AppContainerStackParams, APP_CONTAINER_ROUTES.Base>,
  StackNavigationProp<AppContainerStackParams, APP_CONTAINER_ROUTES.NewOrder>
>;

export const useHubCardNavigation = () => {
  const { navigate } = useNavigation<Navigation>();

  const navigateToViewAccount = (cardData: HubCardData) => {
    navigate(APP_MODAL_ROUTES.LocationManager, {
      params: {
        restaurantName: getTranslationValue(cardData.title),
        restaurantUUID: cardData.restaurant_uuid,
        supplierUUID: cardData.supplier_uuid,
      },
      screen: LOCATION_MANAGER_ROUTES.ViewAccount,
    });
  };

  const navigateToInvoiceDetail = (cardData: OverduePaymentHubCardData) => {
    navigate(APP_MODAL_ROUTES.InvoiceDetailModal, {
      invoiceUUID: cardData.order_invoice_uuid,
      // disabled payments for now
      renderPayable: false,
    });
  };

  const navigateToItemDetails = (
    restaurantUUID: string,
    supplierUUID: string,
    variantPackUUID: string,
    origin: string,
  ) => {
    navigate(APP_MODAL_ROUTES.ItemDetails, {
      origin,
      restaurantUUID,
      supplierUUID,
      variantPackUUID,
    });
  };

  const navigateToOrderManagement = () => {
    navigate(INSIGHTS_HUB_ROUTES.OrderManagement);
  };

  const navigateToRelevantScreen = (cardData: HubCardData) => {
    switch (cardData.card_type) {
      case HubCardType.ChurnRisk:
        navigateToViewAccount(cardData);
        break;
      case HubCardType.LostItem:
        navigateToItemDetails(
          cardData.restaurant_uuid,
          cardData.supplier_uuid,
          cardData.variant_pack_uuid,
          INSIGHTS_HUB_ROUTES.Base,
        );
        break;
      case HubCardType.OverduePayment:
        navigateToInvoiceDetail(cardData);
        break;
      default:
        break;
    }
  };

  return {
    navigateToItemDetails: navigateToItemDetails,
    navigateToOrderManagement,
    navigateToRelevantScreen,
    navigateToViewAccount,
  };
};
